import crypto, { type BinaryToTextEncoding } from "crypto"

export const getHash = (
    data: string,
    algorithm: string,
    encoding: BinaryToTextEncoding
): string | null =>
    (data.trim() &&
        crypto
            .createHash(algorithm)
            .update(data.trim().toLowerCase())
            .digest(encoding)) ||
    null
export const getSha256 = (data: string): string | null => getHash(data, "sha256", "hex")

export const generateLocalSessionId = (): string => {
    const uniqueIdentifier = `${Date.now()}-${Math.random()}`
    return getHash(uniqueIdentifier, "sha256", "hex") || "default-session-id"
}
